<main class="main-wrap" *ngIf="isShows">
  <div class="left-sidebar-wrapper">
    <app-company-side-bar-page></app-company-side-bar-page>
  </div>
  <div class="middle-wrapper">
    <app-company-details-component *ngIf="cin" [company_name]="company_name" [tab]="tab" [cin]="cin"
      [company_url]="company_url" [id]="id">
    </app-company-details-component>
  </div>
  <div class="right-sidebar-wrapper" *ngIf="deviceType!== 'mobile'">
    <app-company-right-side-bar-page></app-company-right-side-bar-page>
  </div>
</main>
